import { gql } from "@apollo/client";

export const GET_ALL_USUARIO_AUTORIZADOR = gql`
    query GetAllUsuarioAutorizador{
        allUsuarioAutorizadorPrecioMasivo{
            idUsuario,
            nombre,
            apellido
        } 
    }
`;